/* eslint-disable */
export default {
  notActivated: '비활성',
} as const;

// @key: @#@"notActivated"@#@ @source: @#@"Inactive"@#@
